<pgh-modal-window size="md plus">
  <div modal-title class="title-with-icon service-title">
    <h4 class="modal-title">{{modalData.redeemedTitle}}</h4>
  </div>
  <div modal-body>
    <p class="content">{{modalData.redeemedContent}}</p>
    <mat-divider></mat-divider>
  </div>
  <div modal-footer class="footer-option">
    <button mat-flat-button color="accent" type="button" (click)="closeModal()">Close</button>
  </div>
</pgh-modal-window>
